import styled from 'styled-components';

import { MOBILE } from '@/nova/theme/tokens';

import { Poster, ROW_ACTION_PX } from '../VideoLibrary/VideoLibrary.styles';

/* A library grid's skeleton cards (Video Ads, Image Banners, Mini-games, HTML5 Banners, Landing Pages): the real card's
   own box (SavedCard, SavedBody, SavedFoot) with a skeleton in each slot, so the cards that replace them keep the same
   size. */

export { SavedBody, SavedCard, SavedFoot } from '../VideoLibrary/VideoLibrary.styles';

/** The poster's 4:5 frame (a fixed small thumb in a phone's row), not a button here. */
export const PosterSlot = styled(Poster)`
  cursor: default;
`;

/** A text line's box at the real line's font size, so the skeleton line inside is as tall as the text it stands for. */
export const Line = styled.span<{ $size: number }>`
  display: block;
  min-width: 0;
  font-size: ${({ $size }) => $size}px;
`;

/** The room the card's action buttons take on the meta row (30px; a phone row's full tap target). */
export const ActionSlot = styled.span`
  flex: 0 0 auto;
  width: 30px;
  height: 30px;

  ${MOBILE} {
    width: ${ROW_ACTION_PX}px;
    height: ${ROW_ACTION_PX}px;
  }
`;

/** What is loading, for assistive tech only (the skeleton cards are hidden from it). */
export const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`;
